import { Card, Fade, Grid, LinearProgress, Paper } from '@material-ui/core'
import Step from '@material-ui/core/Step'
import StepButton from '@material-ui/core/StepButton'
import Stepper from '@material-ui/core/Stepper'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import deepEqual from 'deep-equal'
import {
  AuthContext,
  Autocomplete,
  Checkbox,
  CrudForm,
  DatePicker,
  Snackbar,
  TextField,
  autocompleteHelpers
} from 'elentari'
import arrayMutators from 'final-form-arrays'
import React, { Fragment, useContext, useEffect, useRef, useState } from 'react'
import { Field } from 'react-final-form'
import ComplexDialog from '../../components/ComplexDialog'
import ChatCard from '../Chats/ChatCard'
import { useAbility } from '../Usuarios'
import BlacklistsBloqueiosForm from './BlacklistsBloqueios/BlacklistsBloqueiosForm'
import InformacoesForm from './Informacoes/InformacoesForm'
import LogAlteracoesCard from './Log/LogAlteracoesCard'
import MotoristaForm from './Motoristas/MotoristaForm'
import ReferenciasForm from './Referencias/ReferenciasForm'
import solicitacoesRepository from './SolicitacoesRepository'
import VeiculosForm from './Veiculos/VeiculosForm'
import { StatusColors, StatusEnum } from './components'
import useEntityManager from './useEntityManager'
import * as R from 'ramda'
import { useParams } from 'react-router-dom'
import * as yup from 'yup'
import { CustomDatePicker, CustomTextField } from '../../components/CustomDisabledFields'
import UploadField from '../../components/UploadField'
import { yupContextValidation } from '../../lib/yupContextValidation'
import yupValidation from '../../lib/yupValidation'
import { concatObservacao } from '../../utils/ConcatObservacao'
import { CenarioBySolicitacaoAutocomplete } from '../Cenarios'
import { DocumentosCard } from '../Documentos'
import ClassificacaoCard from './Classificacao/ClassificacaoCard'
import useClassificacaoManager from './Classificacao/useClassificacaoManager'
import SolicitacaoCard from './SolicitacaoCard'
import SolicitacaoPrintCompleta from './SolicitacaoPrintCompleta'
import SolicitacaoPrintProtocolo from './SolicitacaoPrintProtocolo'
import { validateAllRadios } from './changeStepValidate'
import { validateStatusDialog } from './validations'

const { toOption } = autocompleteHelpers

// const loadGestoresByCentroCusto = centroCustoId => async inputValue => {
//   if (centroCustoId) {
//     const response = await usuariosRepository.listGestoresByCentroCusto({
//       centroCustoId,
//       usuario: inputValue,
//       order: 'usuario asc',
//       limit: 5
//     })
//     if (response.ok) {
//       return response.data.map(toOption('usuario'))
//     }
//   }
//   return []
// }

const opcoesMotivosPendencias = [
  {
    id: 'Proprietário'
  },
  {
    id: 'Referências Comerciais'
  },
  {
    id: 'Referências Pessoais'
  },
  {
    id: 'Cadastro KMM'
  },
  {
    id: 'Documentos'
  },
  {
    id: 'GR Externa'
  },
  {
    id: 'Outros'
  }
]

const loadMotivosPendencias = inputValue => {
  return new Promise(resolve => {
    const opcoes = opcoesMotivosPendencias.map(toOption('id')).filter(el => {
      if (inputValue) {
        const inputValueCapitalize =
          inputValue.charAt(0).toUpperCase() + inputValue.substring(1)
        const idNormalized = el.id
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
        return idNormalized.startsWith(inputValueCapitalize)
      }
      return el
    })
    resolve(opcoes)
  })
}

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(6),
    marginTop: theme.spacing(2)
  },
  buttonContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center'
  },
  backButton: {
    marginRight: theme.spacing(1)
  },
  card: {
    paddingTop: 16,
    paddingLeft: 16,
    paddingRight: 16
  },
  mainStepper: {
    overflowX: 'scroll'
  },
  stepBtn: {
    padding: '0px 16px'
  },
  stepperPaper: {
    position: 'fixed',
    top: 64,
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 1050
  },
  stepper: {
    padding: theme.spacing(3)
  },
  form: {
    marginTop: theme.spacing(3)
  },
  pendente: {
    fontSize: '0.695em',
    height: '100%',
    backgroundColor: StatusColors.PENDENTE,
    '&:hover': {
      color: 'white',
      backgroundColor: StatusColors.PENDENTE_DARK
    }
  },
  pendenteGestor: {
    fontSize: '0.695em',
    height: '100%',
    lineHeight: '105%',
    backgroundColor: StatusColors.PENDENTEGESTOR,
    '&:hover': {
      color: 'white',
      backgroundColor: StatusColors.PENDENTEGESTOR_DARK
    }
  },
  reanalise: {
    fontSize: '0.695em',
    height: '100%',
    lineHeight: '105%',
    backgroundColor: StatusColors.REANALISE,
    '&:hover': {
      color: 'white',
      backgroundColor: StatusColors.REANALISE_DARK
    }
  },
  habilitarEdicao: {
    fontSize: '0.695em',
    height: '100%',
    lineHeight: '105%'
  },
  liberada: {
    fontSize: '0.695em',
    height: '100%',
    backgroundColor: StatusColors.LIBERADA,
    '&:hover': {
      color: 'white',
      backgroundColor: StatusColors.LIBERADA_DARK
    }
  },
  liberadaComPendencia: {
    fontSize: '0.695em',
    height: '100%',
    lineHeight: '105%',
    backgroundColor: StatusColors.LIBERADACOMPENDENCIA,
    '&:hover': {
      color: 'white',
      backgroundColor: StatusColors.LIBERADACOMPENDENCIA_DARK
    }
  },
  liberarComMonitoramento: {
    fontSize: '0.695em',
    height: '100%',
    lineHeight: '105%',
    backgroundColor: StatusColors.LIBERADAMONITORAMENTO,
    '&:hover': {
      color: 'white',
      backgroundColor: StatusColors.LIBERADAMONITORAMENTO_DARK
    }
  },
  liberadaGestor: {
    fontSize: '0.695em',
    height: '100%',
    backgroundColor: StatusColors.LIBERADAGESTOR,
    '&:hover': {
      color: 'white',
      backgroundColor: StatusColors.LIBERADAGESTOR_DARK
    }
  },
  naoRecomendada: {
    fontSize: '0.695em',
    height: '100%',
    backgroundColor: StatusColors.NAORECOMENDADA,
    '&:hover': {
      color: 'white',
      backgroundColor: StatusColors.NAORECOMENDADA_DARK
    }
  },
  cancelada: {
    fontSize: '0.695em',
    height: '100%',
    backgroundColor: StatusColors.CANCELADA,
    '&:hover': {
      color: 'white',
      backgroundColor: StatusColors.CANCELADA_DARK
    }
  },
  delegarAssistente: {
    fontSize: '0.695em',
    height: '100%',
    lineHeight: '105%',
    backgroundColor: StatusColors.DELEGARASSISTENTE,
    '&:hover': {
      color: 'white',
      backgroundColor: StatusColors.DELEGARASSISTENTE_DARK
    }
  }
}))

function getSteps() {
  return [
    'Informações gerais',
    'Blacklist / Bloqueios',
    'Motorista',
    'Veículos',
    'Referências',
    'Alterações / Comentários',
    'Documentos',
    'Classificação'
  ]
}

function getStepContent(
  activeStep,
  props,
  values,
  classes,
  cannotUpdate,
  formChange,
  match,
  entityManager,
  classificacaoManager,
  radioErrors,
  analiseDocumentos
) {
  switch (activeStep) {
    case 0:
      return (
        <InformacoesForm
          {...props}
          values={values}
          cannotUpdate={cannotUpdate}
        />
      )
    case 1:
      return (
        <BlacklistsBloqueiosForm
          {...props}
          values={values}
          cannotUpdate={cannotUpdate}
        />
      )
    case 2:
      return (
        <MotoristaForm
          {...props}
          values={values}
          cannotUpdate={cannotUpdate}
          formChange={formChange}
        />
      )
    case 3:
      return (
        <VeiculosForm
          {...props}
          values={values}
          cannotUpdate={cannotUpdate}
          formChange={formChange}
        />
      )
    case 4:
      return (
        <ReferenciasForm
          {...props}
          values={values}
          cannotUpdate={cannotUpdate}
          formChange={formChange}
        />
      )
    case 5:
      return (
        <Grid container spacing={6} className={classes.root}>
          <Grid item xs={12} lg={6}>
            <LogAlteracoesCard {...props} />
          </Grid>
          <Grid item xs={12} lg={6}>
            <ChatCard {...props} cannotUpdate={cannotUpdate} />
          </Grid>
        </Grid>
      )
    case 6:
      return <DocumentosCard match={match} cannotUpdate={cannotUpdate} />
    case 7:
      return (
        <ClassificacaoCard
          classificacaoManager={classificacaoManager}
          entityManager={entityManager}
          match={match}
          radioErrors={radioErrors}
          analiseDocumentos={analiseDocumentos}
        />
      )
    default:
      return 'Unknown'
  }
}

const MiniStepper = props => {
  const { steps, activeStep, elementRef, handleStep, values } = props
  const classes = useStyles()
  const [miniStepper, setMiniStepper] = useState(false)

  const handleScroll = () => {
    const position = elementRef.current.getBoundingClientRect()
    if (position.y - 40 < 0 && miniStepper === false) {
      setMiniStepper(true)
      return
    }
    if (position.y - 40 > 0 && miniStepper === true) {
      setMiniStepper(false)
    }
  }

  useEffect(() => {
    const main = document.getElementsByTagName('main')[0]
    main.addEventListener('scroll', handleScroll)
    return () => {
      main.removeEventListener('scroll', handleScroll)
    }
  })

  return (
    <Fade in={miniStepper}>
      <Card className={classes.stepperPaper}>
        <Stepper className={classes.stepper} activeStep={activeStep} nonLinear>
          {steps.map((label, index) => (
            <Step key={label}>
              <StepButton
                disableRipple
                className={classes.stepBtn}
                onClick={handleStep(values, index)}
              >
                {label}
              </StepButton>
            </Step>
          ))}
        </Stepper>
      </Card>
    </Fade>
  )
}

const Form = React.memo(props => {
  const { entityManager, setMensagem, analiseDocumentos } = props
  const [ability] = useAbility()
  const classes = useStyles()
  const { user } = useContext(AuthContext)
  const [activeStep, setActiveStep] = useState(0)
  const [fetching, setFetching] = useState(false)
  const [originalValues, setOriginalValues] = useState({})
  const [radioErrors, setRadioErrors] = useState({})
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    callback: null,
    id: 0,
    mensagem: '',
    isDelegarAssistente: false,
    isPendenteGestor: false,
    isLiberarGestor: false,
    isPendente: false,
    isLiberar: false,
    isLiberadaComPendencia: false,
    isLiberarComMonitoramento: false
  })
  const [values, setValues] = useState()

  const elementRef = useRef()

  const validateRadios = async () => {
    const errors = await validateAllRadios(values)
    setRadioErrors(errors)
  }

  useEffect(() => {
    validateRadios()
    return () => {
      setRadioErrors({})
    }
  }, [values])

  useEffect(() => {
    setOriginalValues(entityManager.item)
  }, [entityManager.item])

  const steps = getSteps()
  const isOnClassificacao = activeStep === 7

  const cannotUpdate =
    ability.cannot('update', 'solicitacoes') ||
    !!entityManager.item.dataTermino ||
    user.realm === 'gestor' ||
    isOnClassificacao

  const scrollTop = () => {
    const stepElement = document.getElementById('content')
    setTimeout(() => {
      stepElement.scrollIntoView()
    }, 200)
  }

  const handleStep = (values, step) => async () => {
    if (!R.isEmpty(values)) {
      setValues(values)
      if (!deepEqual(originalValues, values)) {
        await handleSubmit(values)
      }
      setActiveStep(step)
      if (step === 7) props.classificacaoManager.loadClassificacao()
      scrollTop()
      // const errors = await changeStepValidate(values, activeStep)
      // if (R.isEmpty(errors)) {
      // } else {
      //   const fields = parseObjectKeysToString(errors)
      //   if (activeStep === 3) {
      //     const veiculosErrors = getErrorFromVeiculo(fields).map(
      //       e => e + ' (CRLV legivel)'
      //     )
      //     setMensagem(
      //       `Existem campos obrigatórios não preenchidos: ${veiculosErrors.join(
      //         ', '
      //       )}`
      //     )
      //     return
      //   }
      //   setMensagem(
      //     `Existem campos obrigatórios não preenchidos: ${fields.join(', ')}`
      //   )
      // }
    }
  }

  const formatCheckboxValues = value => {
    if (value === true || value === 'sim') {
      return true
    }
    if (value === false || value === 'nao') {
      return false
    }
    return undefined
  }

  const handleSubmit = async data => {
    scrollTop()
    if (R.isEmpty(data)) {
      return
    }
    setFetching(true)
    setValues({ ...data })
    delete data.mercadoria
    delete data.centroCusto
    delete data.responsavel
    delete data.bloqueios
    delete data.blacklists
    delete data.gsvtechStatus
    delete data.gsvtechId
    const item = entityManager.item || {}
    const motoristaData = data.motorista ?? item.motorista
    const veiculosData = data.veiculos ?? item.veiculos ?? []
    const newData = {
      ...data,
      motorista: motoristaData
        ? {
            ...motoristaData,
            viagens: [],
            sinistros: [],
            cnhLegivel: formatCheckboxValues(motoristaData.cnhLegivel),
            comprovanteValido: formatCheckboxValues(
              motoristaData.comprovanteValido
            ),
            fotoLegivel: formatCheckboxValues(motoristaData.fotoLegivel),
            pessoaFisicaValida: formatCheckboxValues(
              motoristaData.pessoaFisicaValida
            ),
            cnhValida: formatCheckboxValues(motoristaData.cnhValida)
          }
        : undefined,
      veiculos: Array.isArray(veiculosData)
        ? veiculosData.map(veiculo => ({
            ...veiculo,
            proprietario: veiculo.proprietario
              ? {
                  ...veiculo.proprietario,
                  viagens: [],
                  sinistros: [],
                }
              : undefined,
            proprietarioDoc: veiculo.proprietarioDoc
              ? {
                  ...veiculo.proprietarioDoc,
                  viagens: [],
                  sinistros: [],
                }
              : undefined,
            crlvLegivel: formatCheckboxValues(veiculo.crlvLegivel),
            denatranValida: formatCheckboxValues(veiculo.denatranValida),
            anttValida: formatCheckboxValues(veiculo.anttValida),
            qualificacaoValida: formatCheckboxValues(veiculo.qualificacaoValida),
            pessoaJuridicaValida: formatCheckboxValues(
              veiculo.pessoaJuridicaValida
            )
          }))
        : undefined,
      contratoValido: formatCheckboxValues(data.contratoValido),
      referenciasDispensada: formatCheckboxValues(data.referenciasDispensada),
      observacaoInformacoesGerais: concatObservacao(
        data.observacaoInformacoesGerais,
        data.novaObservacaoInformacoesGerais,
        user.name
      ),
      observacaoBlacklistBloqueios: concatObservacao(
        data.observacaoBlacklistBloqueios,
        data.novaObservacaoBlacklistBloqueios,
        user.name
      ),
      observacaoMotorista: concatObservacao(
        data.observacaoMotorista,
        data.novaObservacaoMotorista,
        user.name
      ),
      observacaoContatoMotorista: concatObservacao(
        data.observacaoContatoMotorista,
        data.novaObservacaoContatoMotorista,
        user.name
      ),
      observacaoVeiculos: concatObservacao(
        data.observacaoVeiculos,
        data.novaObservacaoVeiculos,
        user.name
      ),
      observacaoContatoProprietario: concatObservacao(
        data.observacaoContatoProprietario,
        data.novaObservacaoContatoProprietario,
        user.name
      ),
      observacaoReferencias: concatObservacao(
        data.observacaoReferencias,
        data.novaObservacaoReferencias,
        user.name
      ),
      notaInterna: concatObservacao(
        data.notaInterna,
        data.novaNotaInterna,
        user.name
      )
    }
    const response = await entityManager.onSubmit(newData)
    if (response.ok) {
      setValues(response.data)
      setMensagem('Solicitação salva com sucesso!')
    } else {
      setMensagem(response.message)
    }
    setFetching(false)
  }

  const FooterDialog = props => {
    const { status, fonteLiberacao } = props

    const mensagemStatus = `O novo status dessa solicitação será: ${status}`
    const mensagemFonteLiberacao = fonteLiberacao
      ? `A fonte liberação será: ${fonteLiberacao}`
      : ''

    return (
      <Fragment>
        <Typography>{mensagemStatus}</Typography>
        <Typography>{mensagemFonteLiberacao}</Typography>
      </Fragment>
    )
  }

  const handleActionsClick = async ({
    id,
    callback,
    operacao,
    status,
    fonteLiberacao
  }) => {
    setConfirmationDialog({
      open: true,
      callback,
      id,
      footer: (
        <FooterDialog
          status={status || operacao}
          fonteLiberacao={fonteLiberacao}
        />
      ),
      isDelegarAssistente: operacao === 'Reaberto e exclusiva para Assistente',
      isPendenteGestor: operacao === 'Pendente Monitoramento',
      isLiberarGestor: operacao === 'Liberada gestor',
      isLiberarComMonitoramento: operacao === 'Liberada com Monitoramento',
      isPendente: operacao === 'Pendente',
      isLiberadaComPendencia: operacao === 'Liberado com pendência',
      isLiberar: operacao === 'Liberada',
      isNaoRecomendada: operacao === 'Não recomendada'
    })
  }

  const closeDialog = () => {
    setConfirmationDialog({
      open: false,
      callback: null,
      id: 0
    })
  }

  const handleConfirmationDialog = async data => {
    const { id, callback } = confirmationDialog

    if (callback) {
      const response = await callback(id, data)
      if (response.ok) {
        entityManager.getItem()
        setMensagem(`Status alterado com sucesso!`)
        if (
          response.data?.sucessoKmm !== undefined &&
          !response.data.sucessoKmm
        ) {
          setMensagem(`Falha ao sincronizar com KMM!`)
        }
      } else {
        setMensagem(
          R.pathOr(
            'Ops, algo deu errado!',
            ['data', 'error', 'message'],
            response
          )
        )
        entityManager.getItem()
      }
    }
  }

  const customActionsFactory = item => {
    if (item.dataTermino) {
      if (user.realm === 'admin' || user.realm === 'analista_2') {
        return [
          {
            label: 'Habilitar edição',
            props: {
              color: 'secondary',
              className: classes.habilitarEdicao,
              variant: 'contained'
            },
            onClick: () =>
              handleActionsClick({
                id: item.id,
                callback: solicitacoesRepository.removerDataTermino,
                operacao: 'Aberto e a Data de Término será removida.'
              })
          }
        ]
      }
      return []
    }

    const reanalise = {
      can: ['admin', 'analista', 'analista_2'],
      label: 'Reanálise',
      isFinal: false,
      props: {
        color: 'inherit',
        className: classes.reanalise,
        variant: 'contained'
      },
      onClick: () => {
        handleActionsClick({
          id: item.id,
          callback: solicitacoesRepository.reanalise,
          operacao: 'Reanálise'
        })
      }
    }
    const pendente = {
      can: ['admin', 'analista', 'analista_2'],
      label: 'Pendente',
      isFinal: false,
      props: {
        color: 'inherit',
        className: classes.pendente,
        variant: 'contained'
      },
      onClick: () => {
        handleActionsClick({
          id: item.id,
          callback: solicitacoesRepository.pendente,
          operacao: 'Pendente'
        })
      }
    }
    const liberar = {
      can: ['admin', 'analista', 'analista_2'],
      label: 'Liberar',
      isFinal: true,
      props: {
        color: 'inherit',
        className: classes.liberada,
        variant: 'contained'
      },
      onClick: () => {
        handleActionsClick({
          id: item.id,
          callback: solicitacoesRepository.liberar,
          operacao: 'Liberada',
          fonteLiberacao: 'Central de Cadastros'
        })
      }
    }
    const liberarComPendencia = {
      can: ['admin', 'analista', 'analista_2'],
      label: 'Liberar com baixo valor',
      isFinal: true,
      props: {
        color: 'inherit',
        className: classes.liberadaComPendencia,
        variant: 'contained'
      },
      onClick: () => {
        handleActionsClick({
          id: item.id,
          callback: solicitacoesRepository.liberarComPendencia,
          operacao: 'Liberado com pendência',
          status: 'Liberada',
          fonteLiberacao: 'Central de Cadastros'
        })
      }
    }
    const cancelar = {
      can: ['admin', 'analista', 'analista_2'],
      label: 'Cancelar',
      isFinal: false,
      props: {
        color: 'inherit',
        className: classes.cancelada,
        variant: 'contained'
      },
      onClick: () => {
        handleActionsClick({
          id: item.id,
          callback: solicitacoesRepository.cancelar,
          operacao: 'Cancelada'
        })
      }
    }
    const liberarGestor = {
      can: ['admin', 'gestor', 'analista', 'analista_2'],
      label: 'Liberar Gestor',
      isFinal: true,
      props: {
        color: 'inherit',
        className: classes.liberadaGestor,
        variant: 'contained'
      },
      onClick: () => {
        handleActionsClick({
          id: item.id,
          callback: solicitacoesRepository.liberarGestor,
          operacao: 'Liberada gestor',
          status: 'Liberada',
          fonteLiberacao: 'Gestor'
        })
      }
    }
    const naoRecomendar = {
      can: ['admin', 'gestor', 'analista', 'analista_2'],
      label: 'Não recomendar',
      isFinal: true,
      props: {
        color: 'inherit',
        className: classes.naoRecomendada,
        variant: 'contained'
      },
      onClick: () => {
        handleActionsClick({
          id: item.id,
          callback: solicitacoesRepository.naoRecomendar,
          operacao: 'Não recomendada',
          status: 'Liberada',
          fonteLiberacao: 'Não Recomendada'
        })
      }
    }
    const delegarAssistente = {
      can: ['analista'],
      label: 'Delegar assistente',
      isFinal: false,
      props: {
        color: 'inherit',
        className: classes.delegarAssistente,
        variant: 'contained'
      },
      onClick: () => {
        handleActionsClick({
          id: item.id,
          callback: solicitacoesRepository.delegarAssistente,
          operacao: 'Reaberto e exclusiva para Assistente'
        })
      }
    }

    let actions = []
    if (![StatusEnum.ABERTO, StatusEnum.REABERTO].includes(item.status)) {
      actions.push(cancelar)
    }
    switch (item.status) {
      case StatusEnum.ANALISE:
      case StatusEnum.REANALISE:
        actions.push(
          delegarAssistente,
          pendente,
          // pendenteGestor,
          liberar,
          liberarGestor,
          liberarComPendencia
        )
        if (user.realm !== 'gestor') actions.push(naoRecomendar)
        break
      case StatusEnum.LIBERADACOMPENDENCIA:
        if (user.realm === 'analista_2') {
          actions.push(liberar, liberarGestor, naoRecomendar)
        }
        break
      case StatusEnum.PENDENTEGESTOR:
        actions.push(liberar)
        actions.push(liberarGestor)
        if (user.realm !== 'analista' || user.realm !== 'analista_2')
          actions.push(naoRecomendar)
        break
      case StatusEnum.PENDENTE:
        actions.push(reanalise)
        break
      default:
    }
    // removendo liberar caso tenha bloqueios ou blacklist
    if (
      user.realm !== 'admin' &&
      (item.blacklists?.length || item.bloqueios?.length)
    ) {
      actions = actions.filter(action => action.label !== 'Liberar')
    }
    // if (
    //   (user.realm === 'analista' &&
    //     ['medium', 'bad', 'really_bad'].includes(item.classificacao)) ||
    //   (user.realm === 'analista_2' && item.classificacao === 'really_bad')
    // ) {
    //   actions = actions.filter(
    //     action =>
    //       action.label !== 'Liberar' || action.label !== 'Liberar Gestor'
    //   )
    // }

    const actionsByRealm = actions.filter(action =>
      action.can.includes(user.realm)
    )
    if (!R.isEmpty(radioErrors)) {
      return actionsByRealm.filter(action => !action.isFinal)
    }
    return actionsByRealm
  }

  const customActions =
    activeStep === 7 ? customActionsFactory(entityManager.item) : []

  const validate = async values => {
    return {
      ...(await yupValidation(
        yup.object().shape({
          status: yup
            .string()
            .nullable()
            .required('Obrigatório')
        })
      )(values))
    }
  }

  return (
    <CrudForm
      {...props}
      {...entityManager}
      onGoBack={props.history.goBack}
      item={values || entityManager.item}
      hideGoBack={isOnClassificacao}
      hideSubmit={cannotUpdate}
      validate={validate}
      disableSubmit={cannotUpdate}
      onSubmit={handleSubmit}
      formProps={{
        mutators: { ...arrayMutators }
      }}
      customActions={customActions}
    >
      {({ values, form }) => (
        <div>
          <MiniStepper
            elementRef={elementRef}
            steps={steps}
            activeStep={activeStep}
            handleStep={handleStep}
            values={values}
          />
          <Card className={classes.mainStepper}>
            <Stepper activeStep={activeStep} nonLinear>
              {steps.map((label, index) => (
                <Step key={label}>
                  <StepButton onClick={handleStep(values, index)}>
                    {label}
                  </StepButton>
                </Step>
              ))}
            </Stepper>
          </Card>
          {fetching && <LinearProgress />}
          {!isOnClassificacao && (
            <Paper ref={elementRef} className={classes.form}>
              {getStepContent(
                activeStep,
                props,
                values,
                classes,
                cannotUpdate,
                form.change,
                props.match,
                entityManager,
                props.classificacaoManager,
                radioErrors,
                analiseDocumentos
              )}
            </Paper>
          )}
          {isOnClassificacao && (
            <div ref={elementRef} className={classes.form}>
              {getStepContent(
                activeStep,
                props,
                values,
                classes,
                cannotUpdate,
                form.change,
                props.match,
                entityManager,
                props.classificacaoManager,
                radioErrors,
                analiseDocumentos
              )}
            </div>
          )}
          <ComplexDialog
            open={!!confirmationDialog.open}
            buttonLabel="Não"
            handleClose={closeDialog}
            fullWidth
            primaryAction={handleConfirmationDialog}
            title="Deseja confirmar essa operação?"
            footer={confirmationDialog.footer}
            height={confirmationDialog.isLiberarGestor ? 'auto' : undefined}
            validate={yupContextValidation(validateStatusDialog, {
              validateCenario:
                confirmationDialog.isLiberar ||
                confirmationDialog.isLiberarComMonitoramento ||
                confirmationDialog.isLiberarGestor ||
                confirmationDialog.isLiberadaComPendencia ||
                confirmationDialog.isNaoRecomendada
            })}
            primaryActionButtonLabel="Confirmar"
          >
            {confirmationDialog.isDelegarAssistente && (
              <>
                <Typography gutterBottom>
                  Informe o motivo e o que você já fez na solicitação
                </Typography>
                <Field
                  fullWidth
                  multiline
                  rows={5}
                  label="Nota Interna"
                  name="notaInterna"
                  component={CustomTextField}
                />
              </>
            )}
            {confirmationDialog.isPendente && (
              <>
                <Typography gutterBottom>
                  Selecione o motivo da pendência
                </Typography>
                <Field
                  fullWidth
                  label="Motivos"
                  name="motivoPendencia"
                  loadOptions={loadMotivosPendencias}
                  component={Autocomplete}
                  isMulti
                />
              </>
            )}
            {confirmationDialog.isLiberarGestor && (
              <>
                <Grid container spacing={4} justifyContent="center">
                  {entityManager.item?.blacklists?.length ||
                  entityManager.item?.bloqueios?.length ? (
                    <Grid item xs={12}>
                      <Typography variant="h5" gutterBottom color="primary">
                        ATENÇÃO: Motorista com bloqueios!
                      </Typography>
                    </Grid>
                  ) : null}
                  <Grid item xs={12}>
                    <Field
                      fullWidth
                      isMulti
                      label="Observação"
                      name="observacaoLiberadaGestor"
                      component={TextField}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <CenarioBySolicitacaoAutocomplete
                      idSolicitacao={entityManager.item.id}
                      statusSolicitacao={StatusEnum.LIBERADAGESTOR}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Field
                      fullWidth
                      name="validate"
                      label="Data Validade Motorista"
                      component={CustomDatePicker}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Field
                      fullWidth
                      label="Monitorar"
                      name="monitorar"
                      component={Checkbox}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Field
                      fullWidth
                      name="dataBloqueio"
                      label="Data de Bloqueio"
                      component={DatePicker}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Field
                      accept=".jpg,.jpeg,.png,.pdf"
                      component={UploadField}
                      label="Anexo de liberação gestor"
                      name="anexoLiberadaGestor"
                    />
                  </Grid>
                </Grid>
              </>
            )}
            {confirmationDialog.isLiberar && (
              <>
                <Grid container spacing={4} justifyContent="center">
                  {entityManager.item?.blacklists?.length ||
                  entityManager.item?.bloqueios?.length ? (
                    <Grid item xs={12}>
                      <Typography variant="h5" gutterBottom color="primary">
                        ATENÇÃO: Motorista com bloqueios!
                      </Typography>
                    </Grid>
                  ) : null}
                  <Grid item xs={12}>
                    <CenarioBySolicitacaoAutocomplete
                      fullWidth
                      idSolicitacao={entityManager.item.id}
                      statusSolicitacao={StatusEnum.LIBERADA}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Field
                      fullWidth
                      name="validate"
                      label="Data Validade Motorista"
                      component={CustomDatePicker}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Field
                      fullWidth
                      label="Monitorar"
                      name="monitorar"
                      component={Checkbox}
                    />
                  </Grid>
                </Grid>
              </>
            )}
            {confirmationDialog.isLiberadaComPendencia && (
              <>
                <Grid container spacing={4} justifyContent="center">
                  {entityManager.item?.blacklists?.length ||
                  entityManager.item?.bloqueios?.length ? (
                    <Grid item xs={12}>
                      <Typography variant="h5" gutterBottom color="primary">
                        ATENÇÃO: Motorista com bloqueios!
                      </Typography>
                    </Grid>
                  ) : null}

                  <Grid item xs={12}>
                    <CenarioBySolicitacaoAutocomplete
                      statusSolicitacao={StatusEnum.LIBERADACOMPENDENCIA}
                      idSolicitacao={entityManager.item.id}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Field
                      fullWidth
                      name="validate"
                      label="Data Validade Motorista"
                      component={CustomDatePicker}
                    />
                  </Grid>
                </Grid>
              </>
            )}
            {confirmationDialog.isNaoRecomendada && (
              <Grid container spacing={4} justifyContent="center">
                <Grid item xs={12}>
                  <CenarioBySolicitacaoAutocomplete
                    statusSolicitacao={StatusEnum.NAORECOMENDADA}
                    idSolicitacao={entityManager.item.id}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Field
                    fullWidth
                    disabled
                    name="validate"
                    label="Data Validade Motorista"
                    component={CustomDatePicker}
                  />
                </Grid>
              </Grid>
            )}
          </ComplexDialog>
        </div>
      )}
    </CrudForm>
  )
})

const SolicitacaoForm = props => {
  const classes = useStyles()
  const printRefProtocolo = useRef()
  const printRefCompleto = useRef()
  const [mensagem, setMensagem] = useState('')
  const { id } = useParams()
  const classificacaoManager = useClassificacaoManager({
    setMessage: setMensagem,
    solicitacaoId: id
  })
  const entityManager = useEntityManager({ repository: solicitacoesRepository })
  let composicao = []
  let proprietarioCavalo = {}
  const analiseDocumentos = !!entityManager.item?.analiseDocumentos
  const veiculos = entityManager.item.veiculos ?? []

  if (veiculos.length > 0) {
    composicao = entityManager.item.veiculos.map(v => v.placa)
    proprietarioCavalo = veiculos[0].proprietario
  }

  return (
    <div id="content">
      {!entityManager.isNew && (
        <div className={classes.card}>
          <SolicitacaoCard
            showResumo
            match={props.match}
            printRef={printRefProtocolo}
            printRefCompleto={printRefCompleto}
            empresa={entityManager.item?.empresa?.sigla}
            nomeMotorista={entityManager.item?.motorista?.nome}
            cpfMotorista={entityManager.item?.motorista?.cpf}
            nomeEmbarcador={entityManager.item?.nomeEmbarcador}
            nomeProprietario={proprietarioCavalo?.nomeRazaoSocial}
            cpfCnpjProprietario={proprietarioCavalo?.cpfcnpj}
            mercadoria={entityManager.item?.mercadoria?.descricao}
            cliente={entityManager.item?.cliente}
            valorCarga={entityManager.item?.valorCarga}
            centroCusto={entityManager.item?.centroCusto}
            dataTermino={entityManager.item?.dataTermino}
            status={entityManager.item?.status}
            fonteLiberacao={entityManager.item?.fonteLiberacao}
            composicao={composicao}
            analiseDocumentos={analiseDocumentos}
          />
        </div>
      )}
      <Form
        {...props}
        classificacaoManager={classificacaoManager}
        setMensagem={setMensagem}
        entityManager={entityManager}
        analiseDocumentos={analiseDocumentos}
      />
      <Snackbar
        message={mensagem}
        autoHideDuration={6000}
        onClose={() => setMensagem('')}
      />
      <div hidden>
        <Grid ref={printRefProtocolo}>
          <SolicitacaoPrintProtocolo item={entityManager.item} />
        </Grid>
        <Grid ref={printRefCompleto}>
          <SolicitacaoPrintCompleta item={entityManager.item} />
        </Grid>
      </div>
    </div>
  )
}

export default SolicitacaoForm
